export default __webpack_public_path__ + "static/media/1865.e7dbbba9.png";